module.exports = __webpack_public_path__ + "static/media/market_fallback_image.b3341750.jpg";